import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import './VisionMission.css';

function VisionIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      <line x1="2" y1="12" x2="22" y2="12" />
    </svg>
  );
}

function MissionIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22,4 12,14.01 9,11.01" />
    </svg>
  );
}

function VisionMission() {
  const ref = useRevealChildren();

  return (
    <section className="vm-section" ref={ref}>
      <div className="container">
        <div className="vm-grid">
          <div className="vm-card vision reveal">
            <div className="vm-icon"><VisionIcon /></div>
            <div className="vm-label">Our Vision</div>
            <h3 className="vm-title">Empowering Self-Reliance</h3>
            <p className="vm-text">
              Building a future that empowers communities to achieve self-reliance,
              emphasizing financial and social inclusion while living in harmony
              with nature and the surrounding environment.
            </p>
          </div>
          <div className="vm-card mission reveal reveal-d2">
            <div className="vm-icon"><MissionIcon /></div>
            <div className="vm-label">Our Mission</div>
            <h3 className="vm-title">Holistic Growth</h3>
            <p className="vm-text">
              To foster holistic growth through ecological amelioration and economic
              upliftment of all stakeholders through participatory approach.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VisionMission;
